import { useTranslation } from "react-i18next";
import { useTelawah } from "../../../hooks/useTelawah";
import { localeMoment, classNames } from "../../../helpers";
import { isValidMoment } from "../../../helpers/date_helpers";
import UserProfilePictureAvatar from "../../avatar/UserProfilePictureAvatar";
import { getSessionState } from "../../sessions/helper";
import { BookOpenIcon, TrashIcon } from "@heroicons/react/outline";
import AppButton from "../../buttons/AppButton";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import { SlotStates } from "../../../api/models/ScheduleSlotModel";
import { useAuth } from "../../../context/AuthContext";

type SessionCardProps = {
  session: CalendarScheduleSlotModel;
  setIsOpen?: () => void;
  cancel: boolean;
};

export default function SessionCardInfoContainer({
  session,
  setIsOpen,
  cancel,
}: SessionCardProps) {
  const { t } = useTranslation("", {
    keyPrefix: "page.sessionInfo",
  });
  const { currentUser }: any = useAuth();
  const { getTelawahById } = useTelawah();
  const state = () => {
    switch (session?.state) {
      case SlotStates.not_started:
        return "scheduled";
      case SlotStates.done:
        return "done";
      case SlotStates.upcoming:
        return "upcoming";
      case SlotStates.in_progress:
        return "in_progress";
    }
  };
  return (
    <>
      <div className=" w-full  md:pt-6 ">
        <div className="flex  gap-6 flex-col  w-full">
          <div className="flex  flex-col  gap-2 md:gap-[6px]  md:px-4 xl:px-6">
            <h1 className="font-bold text-lg leading-6 flex text-gray-700">
              <span>{t("session")} #</span>
              {/* if session number not exist will set empty string */}
              <span>{session?.sessionNumber ?? ""}</span>
            </h1>
            <div className="flex justify-between items-center ">
              <div className=" flex  items-center text-sm justify-between text-gray-500 ">
                <div className="  flex rounded-full gap-1 items-center justify-between">
                  {localeMoment(session!.date!).format("ddd d MMM")}
                  <p>-</p>
                </div>
                <div className="flex  items-center justify-between">
                  {isValidMoment(session.startTime) && (
                    <div className=" px-1 flex rounded-full items-center justify-between">
                      {localeMoment(session!.startTime!).format("hh:mm")}
                    </div>
                  )}
                  <p>-</p>
                  {isValidMoment(session.endTime) && (
                    <div className=" px-1 flex rounded-full items-center justify-between">
                      {localeMoment(session!.endTime!).format("hh:mm A")}
                    </div>
                  )}
                </div>
              </div>
              <div>{getSessionState(`${state()}`)}</div>
            </div>
          </div>
          <div className="w-full flex flex-col gap-2 md:px-4 lg:px-3 xl:px-6">
            <div className="w-full">
              <div className="flex gap-3   items-center">
                <UserProfilePictureAvatar
                  profilePictureUrl={session.student?.profile_picture_url}
                  className="inline-block h-8 w-8 rounded-full"
                  alt="sand-user-img"
                />
                <div className="flex   py-[6px] ">
                  <h3 className="text-sm font-medium text-gray-600">
                    {session.student?.fullName ??
                      session.student?.firstName +
                        " " +
                        session.student?.lastName}
                  </h3>
                </div>
              </div>
            </div>
            <div className="w-full ">
              <div className=" flex gap-3 ">
                <div className="flex justify-center items-center w-8">
                  <BookOpenIcon className="text-gray-400 w-6 h-6" />
                </div>
                <div className="flex   py-[6px] ">
                  <h3 className="text-sm font-medium text-gray-600">
                    {getTelawahById(
                      +session?.student?.telawah_id! as number
                    )?.[0]?.name ??
                      getTelawahById(+currentUser?.telawah_id)?.[0]?.name}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div
            className={classNames(
              "w-full flex items-center flex-row-reverse  md:px-6 py-2  rounded-md rounded-t-none ",
              cancel ? "border-t border-gray-200 " : ""
            )}
          >
            {cancel && (
              <AppButton
                onClick={() => !!setIsOpen && setIsOpen()}
                buttonShape="primary-danger"
              >
                <div className="flex gap-2">
                  <TrashIcon className="w-5 h-5" />
                  {t("cancel")}
                </div>
              </AppButton>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
